
import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

export default {
  name: 'ContactUs',

  props: {
    brand: {
      type: String,
      default: PROJECT_BRANDS.reverse,
    },
  },

  computed: {
    showSection() {
      return this.brand === PROJECT_BRANDS.reverse;
    },
    emailTextContent() {
      return this.brand === PROJECT_BRANDS.reverse
        ? this.$t('contact.info.email')
        : this.$t('contactMuscleCharge.info.email');
    },
  },
};
